import { ComponentKey } from "@certa/studio-core";
import { StudioNodeType } from "./useStudioAPI.types";

export const ComponentTypeToNodeType = {
  [ComponentKey.SWIMLANES]: StudioNodeType.SWIMLANE,
  [ComponentKey.STEPS]: StudioNodeType.STEP,
  [ComponentKey.FIELDS]: StudioNodeType.FIELD
};

export const NodeTypeToComponentKey = {
  [StudioNodeType.SWIMLANE]: ComponentKey.SWIMLANES,
  [StudioNodeType.STEP]: ComponentKey.STEPS,
  [StudioNodeType.FIELD]: ComponentKey.FIELDS
} as const;
